import { PureComponent } from "react";

import { isInPortal } from "utilities/portal/portal";
import { routes } from "utilities/routes";

import { BTLink, BTLinkRelative } from "commonComponents/btWrappers/BTLink/BTLink";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";
import TextTruncate from "commonComponents/utilities/TextTruncate/TextTruncate";

export interface IBillPurchaseOrderLinkResponse {
    builderId: number;
    jobId: number;
    id: number;
    title: string;
    isBill: boolean;
    documentType?: number | null;
    amount?: number;
}

export class BillPurchaseOrderLinkCell extends PureComponent<
    IGridCellRenderProps<IBillPurchaseOrderLinkResponse>
> {
    render() {
        const { cellValue, field } = this.props;
        if (!cellValue) {
            return null;
        }

        if (isInPortal({ owner: true })) {
            return (
                <BTLink
                    useAutoSPARouting
                    shouldOpenNewTab
                    to={routes.purchaseOrder.getPrintLink([cellValue.id])}
                >
                    <TextTruncate>{cellValue.title}</TextTruncate>
                </BTLink>
            );
        }

        const route = cellValue.isBill
            ? routes.bill.getDetailsPath(cellValue.id, cellValue.jobId)
            : routes.purchaseOrder.getDetailsPath(cellValue.id, cellValue.jobId);
        return (
            <BTLinkRelative to={route} data-testid={field.full} useAutoSPARouting>
                <TextTruncate>{cellValue.title}</TextTruncate>
            </BTLinkRelative>
        );
    }
}

export const columnBillPurchaseOrderLink: IClientGridColumn<IBillPurchaseOrderLinkResponse> = {
    columnType: GridColumnType.billPurchaseOrderLink,
    Cell: BillPurchaseOrderLinkCell,
};
